module.exports = __webpack_public_path__ + "media/images/icon_mute-75205c72a8b4a41dede667d576f83a3e.svg";